import { Component } from '@theme/component';

class FlyToCart extends Component {
  source;
  destination;
  useSourceSize = false;
  flight;
  frame;

  connectedCallback() {
    super.connectedCallback();
    this.frame = requestAnimationFrame(() => this.animateFlight());
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.flight?.cancel();
    super.disconnectedCallback();
  }

  async animateFlight() {
    if (!this.source?.isConnected || !this.destination?.isConnected) {
      this.remove();
      return;
    }

    const source = this.source.getBoundingClientRect();
    const target = this.destination.getBoundingClientRect();

    if (!source.width || !target.width) {
      this.remove();
      return;
    }

    const size = 68;
    const sx = source.left + source.width / 2 - size / 2;
    const sy = source.top + source.height / 2 - size / 2;
    const tx = target.left + target.width / 2 - size / 2;
    const ty = target.top + target.height / 2 - size / 2;

    const reduced = matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    this.style.setProperty('animation', 'none', 'important');
    this.style.setProperty('display', 'block', 'important');
    this.style.setProperty('translate', 'none', 'important');
    this.style.setProperty('width', `${size}px`, 'important');
    this.style.setProperty('height', `${size}px`, 'important');

    Object.assign(this.style, {
      position: 'fixed',
      left: '0',
      top: '0',
      pointerEvents: 'none',
      zIndex: '2147483647',
      boxSizing: 'border-box',
      border: '5px solid #fdfcfa',
      borderRadius: '16px',
      backgroundColor: '#fdfcfa',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      boxShadow:
        '0 0 0 1px #c9b99e, 0 8px 24px rgb(41 38 35 / 16%)',
      transformOrigin: 'center',
      opacity: '0',
      transform: `translate(${sx}px, ${sy}px)`
    });

    const pose = (x, y, scale) =>
      `translate(${x}px, ${y}px) scale(${scale})`;

    const frames = reduced
      ? [
          {
            transform: pose(tx, ty, 0.35),
            opacity: 0
          },
          {
            transform: pose(tx, ty, 0.35),
            opacity: 1,
            offset: 0.3
          },
          {
            transform: pose(tx, ty, 0.35),
            opacity: 0
          }
        ]
      : [
          {
            transform: pose(sx, sy, 0.85),
            opacity: 0,
            offset: 0
          },
          {
            transform: pose(sx, sy - 10, 1),
            opacity: 1,
            offset: 0.16
          },
          {
            transform: pose(
              sx + (tx - sx) * 0.45,
              sy + (ty - sy) * 0.6 - 18,
              0.82
            ),
            opacity: 1,
            offset: 0.58
          },
          {
            transform: pose(tx, ty, 0.25),
            opacity: 1,
            offset: 0.92
          },
          {
            transform: pose(tx, ty, 0.18),
            opacity: 0,
            offset: 1
          }
        ];

    try {
      this.flight = this.animate(frames, {
        duration: reduced ? 350 : 1050,
        easing: 'cubic-bezier(.22,.61,.36,1)',
        fill: 'both'
      });

      await this.flight.finished;
    } catch {
      // 離開頁面時，動畫可能被取消。
    } finally {
      this.remove();
    }
  }
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}